<template>
  <div class="rhg-col-12">
    <SpaCardsAutoGrid :title="title" :cardsData="spa" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SpaCardsAutoGrid from './components/organisms/spa-cards-auto-grid/SpaCardsAutoGrid.vue'

export default {
  name: 'App',
  components: {
    SpaCardsAutoGrid
  },
  computed: {
    ...mapState(['labelsLoaded', 'loading', 'title', 'spa'])
  },
  data () {
    return {
      isDataLoading: true
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getLabels')
      await this.$store.dispatch('getSpaCard')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.isDataLoading = false
      this.$store.dispatch('sendAnalyticsView')
    }
  }
}
</script>
